const Spacer = () => {
    return (
        <div className = "spacer" style={{height: '7rem'}}></div>
    );
}

export default Spacer;